import usermanagementservice from "../../services/UsersManagementService";

class UserManagementFilter {
  async getUserTableData() {
    try {
      const userTableData = await usermanagementservice.getUserTable();
      return userTableData.data;
    } catch (error) {
      throw error;
    }
  }
  async getUserSessionData() {
    try {
      const userSession = await usermanagementservice.getUserSession();
      return userSession.data;
    } catch (error) {
      throw error;
    }
  }
  async verifyUserData(username) {
    try {
      const result = await usermanagementservice.verifyUser(username);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  async submitUserData(userData) {
    try {
      const result = await usermanagementservice.submitUser(userData);
      return result.data;
    } catch (error) {
      throw error;
    }
  }
  async editUserData(userdata) {
    try {
      let userData = userdata;
      const result = await usermanagementservice.editUser(userData);
      return result.data;
    } catch (error) {
      throw error;
    }
  }

  async validateUserData(userData) {
    try {
      const result = await usermanagementservice.validateUser(userData);
      return result.data;
    } catch (error) {
      throw error;
    }
  }
  async submitResetData(resetData) {
    try {
      const result = await usermanagementservice.resetPassword(resetData);
      return result.data;
    } catch (error) {
      throw error;
    }
  }
  async deleteUserData(userData) {
    try {
      const result = await usermanagementservice.deleteUser(userData);
      return result.data;
    } catch (error) {
      throw error;
    }
  }
}
const usermanagementfilter = new UserManagementFilter();
export default usermanagementfilter;
